import { render, staticRenderFns } from "./UpdateAttachments.vue?vue&type=template&id=b2442032&"
import script from "./UpdateAttachments.vue?vue&type=script&lang=ts&"
export * from "./UpdateAttachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports